var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["category-did-you-mean.j2"] = require( "category-did-you-mean.j2" );
dependencies["category-related.j2"] = require( "category-related.j2" );
dependencies["category-trending.j2"] = require( "category-trending.j2" );
dependencies["brand/brand-breadcrumb.j2"] = require( "brand/brand-breadcrumb.j2" );
dependencies["brand/brand-header-large.j2"] = require( "brand/brand-header-large.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-header.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
var t_1;
t_1 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"isSearch")?"":runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug")));
frame.set("navType", t_1, true);
if(frame.topLevel) {
context.setVariable("navType", t_1);
}
if(frame.topLevel) {
context.addExport("navType", t_1);
}
var t_2;
t_2 = (!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"totalRecordCount") == 0?runtime.contextOrFrameLookup(context, frame, "True"):"");
frame.set("noSearchResults", t_2, true);
if(frame.topLevel) {
context.setVariable("noSearchResults", t_2);
}
if(frame.topLevel) {
context.addExport("noSearchResults", t_2);
}
var t_3;
t_3 = (lineno = 10, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["category.products.correctedQuery"]));
frame.set("correctedQuery", t_3, true);
if(frame.topLevel) {
context.setVariable("correctedQuery", t_3);
}
if(frame.topLevel) {
context.addExport("correctedQuery", t_3);
}
var t_4;
t_4 = (lineno = 11, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["category.products.originalQuery"]));
frame.set("originalQuery", t_4, true);
if(frame.topLevel) {
context.setVariable("originalQuery", t_4);
}
if(frame.topLevel) {
context.addExport("originalQuery", t_4);
}
var t_5;
t_5 = (lineno = 12, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["category.products.query"]));
frame.set("query", t_5, true);
if(frame.topLevel) {
context.setVariable("query", t_5);
}
if(frame.topLevel) {
context.addExport("query", t_5);
}
var t_6;
t_6 = (runtime.contextOrFrameLookup(context, frame, "correctedQuery") || (runtime.contextOrFrameLookup(context, frame, "query") != runtime.contextOrFrameLookup(context, frame, "originalQuery"))?runtime.contextOrFrameLookup(context, frame, "True"):runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("hasCorrection", t_6, true);
if(frame.topLevel) {
context.setVariable("hasCorrection", t_6);
}
if(frame.topLevel) {
context.addExport("hasCorrection", t_6);
}
if(runtime.contextOrFrameLookup(context, frame, "noSearchResults")) {
output += "\n    ";
var t_7;
t_7 = (lineno = 16, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["search_no_results_query-label",runtime.makeKeywordArgs({"params": [runtime.contextOrFrameLookup(context, frame, "query")]})]));
frame.set("headingSlug", t_7, true);
if(frame.topLevel) {
context.setVariable("headingSlug", t_7);
}
if(frame.topLevel) {
context.addExport("headingSlug", t_7);
}
output += "\n    ";
var t_8;
t_8 = "c-search-no-results__h1";
frame.set("headingClass", t_8, true);
if(frame.topLevel) {
context.setVariable("headingClass", t_8);
}
if(frame.topLevel) {
context.addExport("headingClass", t_8);
}
output += "\n";
;
}
else {
output += "\n    ";
var t_9;
t_9 = (lineno = 19, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["search_query-label",runtime.makeKeywordArgs({"params": [runtime.contextOrFrameLookup(context, frame, "query")]})]));
frame.set("headingSlug", t_9, true);
if(frame.topLevel) {
context.setVariable("headingSlug", t_9);
}
if(frame.topLevel) {
context.addExport("headingSlug", t_9);
}
output += "\n    ";
var t_10;
t_10 = "c-search-header__h1";
frame.set("headingClass", t_10, true);
if(frame.topLevel) {
context.setVariable("headingClass", t_10);
}
if(frame.topLevel) {
context.addExport("headingClass", t_10);
}
output += "\n";
;
}
output += "\n\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"isSearch")) {
output += "\n<div class=\"o-column o-extra-small--12 c-search-results-outer dom-category-header\">";
output += "<div class=\"c-search-header\">\n\n        ";
if((runtime.contextOrFrameLookup(context, frame, "query") && !runtime.contextOrFrameLookup(context, frame, "hasCorrection")) || runtime.contextOrFrameLookup(context, frame, "noSearchResults")) {
output += "\n\n            <h1 class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "headingClass"), env.opts.autoescape);
output += "\" data-qa-searched-term>\n\n                ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "headingSlug"), env.opts.autoescape);
output += "\n\n            </h1>\n\n        ";
;
}
if(runtime.contextOrFrameLookup(context, frame, "noSearchResults")) {
output += "\n\n            <div class=\"c-search-no-results\" data-qa-no-results>\n\n                <p class=\"c-search-no-results__p\">\n\n                    ";
output += runtime.suppressValue((lineno = 46, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["search_no-results-subheading"])), env.opts.autoescape);
output += "\n\n                </p>";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"didYouMean") && env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"didYouMean")) > 0) {
output += "\n\n                    ";
env.getTemplate("category-did-you-mean.j2", false, "category/templates/category-header.j2", null, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
t_11.render(context.getVariables(), frame, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
output += t_12
output += "\n\n                ";
})});
}
output += "</div>";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "hasCorrection")) {
output += "\n\n            ";
output += "\n            ";
var t_15;
t_15 = runtime.contextOrFrameLookup(context, frame, "correctedQuery") || runtime.contextOrFrameLookup(context, frame, "query");
frame.set("actualQuery", t_15, true);
if(frame.topLevel) {
context.setVariable("actualQuery", t_15);
}
if(frame.topLevel) {
context.addExport("actualQuery", t_15);
}
output += "\n\n            <div class=\"c-search-corrected-query\">\n\n                <h1 class=\"c-search-corrected-query__h1\" data-qa-searched-term>\n                    ";
output += runtime.suppressValue((lineno = 68, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["search_corrected-query-heading",runtime.makeKeywordArgs({"params": [runtime.contextOrFrameLookup(context, frame, "actualQuery")]})])), env.opts.autoescape);
output += "\n                </h1>\n\n                ";
if(runtime.contextOrFrameLookup(context, frame, "originalQuery")) {
output += "\n\n                    <p class=\"c-search-corrected-query__p\">\n                        ";
output += runtime.suppressValue((lineno = 74, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["search_corrected-query-subheading",runtime.makeKeywordArgs({"params": [runtime.contextOrFrameLookup(context, frame, "originalQuery")]})])), env.opts.autoescape);
output += "\n                    </p>\n\n                ";
;
}
output += "\n\n            </div>\n\n        ";
;
}
;
}
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"relatedQueries") && env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"relatedQueries")) > 0) {
output += "\n\n        ";
env.getTemplate("category-related.j2", false, "category/templates/category-header.j2", null, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
t_16.render(context.getVariables(), frame, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
output += t_17
output += "\n\n        ";
})});
}
output += "\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"trendingTerms") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"trendingTerms")) > 0) {
output += "\n\n        ";
env.getTemplate("category-trending.j2", false, "category/templates/category-header.j2", null, function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
t_20.render(context.getVariables(), frame, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
output += t_21
output += "\n\n        ";
})});
}
output += "\n\n    </div>\n\n</div>\n\n";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"context") == "brands") {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"totalRecordCount") > 0) {
output += "\n\n        ";
env.getTemplate("brand/brand-breadcrumb.j2", false, "category/templates/category-header.j2", null, function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
t_24.render(context.getVariables(), frame, function(t_27,t_25) {
if(t_27) { cb(t_27); return; }
output += t_25
output += "\n\n        ";
env.getTemplate("brand/brand-header-large.j2", false, "category/templates/category-header.j2", null, function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
t_28.render(context.getVariables(), frame, function(t_31,t_29) {
if(t_31) { cb(t_31); return; }
output += t_29
output += "\n\n    ";
})})})});
}
;
}
else {
output += "\n\n    ";
output += "\n\n";
;
}
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-header.j2"] , dependencies)